module.exports = __webpack_public_path__ + "static/nonHeadingYes-00222ba3f16b1b1379a0bb3593046d8f.png";